import { load } from 'recaptcha-v3';
import Pristine from 'pristinejs';

import '../../sass/blocks/contact-form.scss';

(() => {
    const $contactForms = document.querySelectorAll('.contact-form');

    if (!$contactForms) return;

    $contactForms.forEach($contactForm => {
        const $form = $contactForm.querySelector('.contact-form__form');
        const $turnstile = $contactForm.querySelector('.contact-form__turnstile');
        const $turnstileToken = $contactForm?.querySelector('.contact-form__turnstile-token');

        const checkIfTurnstileReady = resolve => {
            const interval = setInterval(() => {
                if (!$turnstileToken.value) return;

                resolve(interval);
                clearInterval(interval);
            }, 100);
        };

        const initForm = () => {
            if (!$form) return;

            const pristine = new Pristine($form);

            $form.addEventListener('submit', e => {
                if ($form.classList.contains('contact-form__form--loading')) return;

                $form.classList.add('contact-form__form--loading');

                e.preventDefault();

                if (!pristine.validate()) {
                    $form.classList.remove('contact-form__form--loading');
                    return;
                }

                if ($turnstile) {
                    const waitUntilReady = new Promise(checkIfTurnstileReady);

                    waitUntilReady.then(() => {
                        $form.submit();
                    });
                } else {
                    $form.submit();
                }
            });
        };

        if (typeof turnstile !== 'undefined') {
            turnstile.render($turnstile, {
                sitekey: $turnstile?.dataset?.sitekey,
                callback: id => {
                    $turnstileToken.value = id;
                }
            });
        } else {
            window.onloadTurnstileCallback = () => {
                if (!$turnstile) return;

                turnstile.render($turnstile, {
                    sitekey: $turnstile?.dataset?.sitekey,
                    callback: id => {
                        $turnstileToken.value = id;
                    }
                });
            };
        }

        initForm();
    });
})()
